(function () {
  function escapeText(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[char];
    });
  }

  function buildProductCard(product) {
    var image = product.images && product.images[0] ? product.images[0].src : '';
    var variant = product.variants && product.variants[0] ? product.variants[0] : null;
    var price = variant ? '$' + Number(variant.price).toFixed(2) : '';
    var title = escapeText(product.title);

    return [
      '<article class="gh-card">',
      '<a href="/products/' + product.handle + '" class="gh-card__media">',
      image ? '<img src="' + image + '" alt="' + title + '" loading="lazy">' : '',
      '</a>',
      '<div class="gh-card__body">',
      '<h3 class="gh-card__title"><a href="/products/' + product.handle + '">' + title + '</a></h3>',
      '<p class="gh-card__price">' + price + '</p>',
      '</div>',
      '</article>',
    ].join('');
  }

  function render(products) {
    var main = document.querySelector('#MainContent');
    if (!main || main.dataset.gardenHearthLayoutOverride === 'true') return;

    main.dataset.gardenHearthLayoutOverride = 'true';
    var cards = products.slice(0, 6).map(buildProductCard).join('');
    main.innerHTML = [
      '<style>',
      '.gh-home{background:#fff;color:#171717;font-family:var(--font-body--family);overflow-x:clip}',
      '.gh-home .page-width{width:min(100% - 56px,1180px);max-width:none;margin-inline:auto;padding-inline:0}',
      '.gh-hero{min-height:540px;display:grid;place-items:end start;position:relative;background:linear-gradient(90deg,rgba(18,18,18,.55),rgba(18,18,18,.08)),url("//garden-hearth.com/cdn/shop/files/image_2026-05-20_06-38-58.png?v=1779259140") center/cover no-repeat}',
      '.gh-hero__box{width:min(560px,100%);margin:0 0 58px;padding:34px 36px 36px;background:rgba(255,255,255,.93);border-radius:16px;box-shadow:0 24px 70px rgba(0,0,0,.18)}',
      '.gh-hero h1{margin:0 0 14px;font-size:clamp(2.35rem,5vw,4.9rem);line-height:.95;letter-spacing:0;color:#121212}',
      '.gh-hero p{margin:0 0 24px;font-size:1.03rem;line-height:1.6;color:rgba(18,18,18,.72)}',
      '.gh-button{display:inline-flex;align-items:center;justify-content:center;min-height:48px;padding:0 22px;border-radius:999px;background:#121212;color:#fff;text-decoration:none;font-weight:700}',
      '.gh-strip{border-block:1px solid rgba(18,18,18,.1);background:#f6f1e9}.gh-strip__inner{min-height:82px;display:flex;align-items:center;justify-content:space-between;gap:24px;font-weight:700;color:#315447}.gh-products{padding:58px 0 76px}.gh-products__head{display:flex;justify-content:space-between;gap:24px;align-items:end;margin-bottom:28px}.gh-products h2{margin:0;font-size:clamp(1.8rem,3vw,3.15rem);letter-spacing:0}.gh-products p{margin:8px 0 0;color:rgba(18,18,18,.68)}.gh-products__head a{color:#121212;font-weight:700}',
      '.gh-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:30px 24px}.gh-card{min-width:0}.gh-card__media{display:block;aspect-ratio:1/1;background:#f7f3ec;border-radius:8px;overflow:hidden}.gh-card__media img{width:100%;height:100%;object-fit:cover;display:block}.gh-card__body{padding-top:14px}.gh-card__title{margin:0 0 6px;font-size:1rem;line-height:1.35;min-height:2.7em}.gh-card__title a{color:#171717;text-decoration:none}.gh-card__price{margin:0;font-weight:800;color:#315447}',
      '.shopify-section-group-footer-group .utilities,.shopify-section-group-footer-group .footer__content-bottom{display:none!important}',
      '@media(max-width:749px){.gh-home .page-width{width:min(100% - 32px,520px)}.gh-hero{min-height:430px}.gh-hero__box{margin-bottom:34px;padding:24px 22px 26px;border-radius:14px}.gh-strip__inner{min-height:74px;justify-content:center;text-align:center}.gh-strip__inner span:nth-child(n+2){display:none}.gh-products{padding:42px 0 58px}.gh-products__head{display:block}.gh-grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:18px 14px}.gh-card__title{font-size:.9rem;min-height:3.9em}}',
      '</style>',
      '<section class="gh-home">',
      '<div class="gh-hero"><div class="page-width"><div class="gh-hero__box">',
      '<h1>Craft that comes with a story</h1>',
      '<p>Handmade garden pieces, folk art and useful outdoor accents selected for a warmer American home.</p>',
      '<a class="gh-button" href="/collections/all">Discover more</a>',
      '</div></div></div>',
      '<div class="gh-strip"><div class="page-width gh-strip__inner"><span>Handmade finds</span><span>US store in USD</span><span>Secure checkout</span></div></div>',
      '<section class="gh-products"><div class="page-width"><div class="gh-products__head"><div><h2>Popular Crafts</h2><p>Every product handcrafted by our artists. Made by people. For people.</p></div><a href="/collections/all">View all</a></div><div class="gh-grid">',
      cards,
      '</div></div></section>',
      '</section>',
    ].join('');
  }

  function init() {
    if (window.location.pathname !== '/' || window.location.hostname.indexOf('garden-hearth') === -1) return;
    fetch('/products.json?limit=6')
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        render(data.products || []);
      })
      .catch(function () {
        render([]);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
